import React from "react";
import { Outlet, useLocation } from "react-router-dom";

import Navbar from "./Navbar";
import BottomNav from "./BottomNav";
import { useAuthGuard } from "../hooks/useAuthGuard";
import { ROUTES, PUBLIC_PATHS } from "../routes/paths";
import "../styles/user-app.css";

const Layout = () => {
  const location = useLocation();
  const isPublic = PUBLIC_PATHS.includes(location.pathname);
  const isAdminRoute = location.pathname.startsWith(ROUTES.ADMIN);
  const { authorized } = useAuthGuard({ enabled: !isPublic && !isAdminRoute });

  if (isPublic || isAdminRoute) {
    return <Outlet />;
  }

  if (!authorized) {
    return null;
  }

  return (
    <div className="mkc-user-app">
      <Navbar />
      <main className="mkc-main">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
};

export default Layout;
